import React from 'react';
import AssignmentIcon from '@mui/icons-material/Assignment';

export const ORD_TYPES = {
    'general': 'Allgemein',	
    'insurance': 'Versicherung',
    'finance': 'Finanzen',
    'energy': 'Energie',	
};

export const ORD_STATES = {
    'default': {
        100: 'Anfrage',
        200: 'Angebot',
        300: 'Vertrag',
        10000: 'storniert',
		310: 'Vertrag abgelaufen',
        10000: 'storniert',
        10100: 'Anfrage storniert',
        10200: 'Angebot storniert',		
        10300: 'Vertrag storniert'						
    },
    'insurance': {
        100: 'Anfrage',
        200: 'Angebot',
        300: 'Vertrag',
        10000: 'storniert',
		310: 'Vertrag abgelaufen',		
        10000: 'storniert',
        10100: 'Anfrage storniert',
        10200: 'Angebot storniert',		
        10300: 'Vertrag storniert'			
    }
};

export const ORD_PRIORITIES = {
    1: 'hoch',
    2: 'mittel',
    3: 'niedrig'
};


export const ORD_TYPE_SYMBOLS = {
    'general': <AssignmentIcon />,
    'insurance': <AssignmentIcon />,
	'finance': <AssignmentIcon />,	
    'energy': <AssignmentIcon />
};

export const ORD_STATE_COLORS = {
    100: '#FF8C00', // Orange
    200: '#008000', // Green
    300: '#0000FF', // Blue
};

